import { Button } from "antd";
import styled from "styled-components";

export const StyledRangeWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const StyledRangeControllers = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 10px 0;
    justify-content: space-between;
`;

export const StyledRangeController = styled(Button)`
    font-size: 13px;
    background-color: ${({ theme }) => theme.additionalTypographyColor};
    padding: 5px;
`;
